import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, FormGroup, Label, Row, Button } from 'reactstrap';
import { ReactSelect, TextField } from 'src/shared/components';
import { connect, useDispatch } from 'react-redux';
import { SelectModel } from 'src/shared/models';
import { getValidationTypes } from 'src/redux/actions/forms.action';
import { Expression } from 'src/shared/models/expression.model';
import { useFormikContext } from 'formik';

interface TextAnswerProps {
  disabled: boolean;
  getValidationTypes: Function;
  attributeValidators: Expression[];
  jumpToSlugOptions: SelectModel[];
}

const TextAnswer: FC<TextAnswerProps> = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [validationsNumber, setValidationsNumber] = useState(1);
  const { setFieldValue, values } = useFormikContext<any>();

  useEffect(() => {
    props.getValidationTypes();
    //eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (!values.validation || values.validation.length !== validationsNumber) {
      setFieldValue('validation', Array(validationsNumber).fill({}).map((_, i) => ({
        validationPattern: values.validation?.[i]?.validationPattern || null,
        validationErrorMessage: values.validation?.[i]?.validationErrorMessage || '',
        jumpToSlug: values.validation?.[i]?.jumpToSlug || null
      })));
    }
  }, [validationsNumber, setFieldValue, values.validation]);
  
  const validationTypes = useMemo(() => {
    if (!props.attributeValidators) return [];
    else
      return props.attributeValidators.map((validator: Expression) => ({
        id: validator.id,
        value: validator.expression,
        label: validator.title,
      }));
  }, [props.attributeValidators]);

  const handleSelectChange = (selectedOption: any, fieldName: string) => {
    setFieldValue(fieldName, selectedOption);
  };  

  const renderValidationFormGroups = () => {
    const formGroups = [];
    for (let i = 0; i < validationsNumber; i++) {
      formGroups.push(
        <React.Fragment key={i}>
          <Row>
            <Col lg="6">
              <FormGroup>
                <Label for={`validation-pattern-${i}`}>{t('common.validationType')}</Label>
                <ReactSelect
                    name={`validation[${i}].validationPattern`}
                    id={`validation-pattern-${i}`}
                  options={validationTypes}
                  onChange={(selectedOption: any) => handleSelectChange(selectedOption, `validation[${i}].validationPattern`)}
                  isDisabled={props.disabled}
                  isClearable
                />
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup>
                <Label  for={`validation-error-message-${i}`}>{t('common.validationErrorMessage')}</Label>
                <TextField 
                name={`validation[${i}].validationErrorMessage`} 
                id={`validation-error-message-${i}`}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue(`validation[${i}].validationErrorMessage`, e.target.value)}
                disabled={props.disabled} 
              />
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup>
                <Label for={`validation-jump-to-slug-${i}`}>{t('forms.jumpToOnValidationFail')}</Label>
                <ReactSelect
                  name={`validation[${i}].jumpToSlug`}
                  id={`validation-jump-to-slug-${i}`}
                  options={props.jumpToSlugOptions}
                  onChange={(selectedOption: any) => handleSelectChange(selectedOption, `validation[${i}].jumpToSlug`)}
                  isDisabled={props.disabled}
                />
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    }
    return formGroups;
  };

  return (
    <>
      {renderValidationFormGroups()}
      <Row className="mt-2">
        <Col xs="auto">
        <Label>{t('forms.addValidation')}</Label>
          <Button
            color="primary"
            className="mr-2"
            id="set-validation-number"
            onClick={() => setValidationsNumber(validationsNumber + 1)}
          >
            {"+"}
          </Button>
          <Button
            color="primary"
            id="set-validation-number"
            onClick={() => setValidationsNumber(validationsNumber - 1)}
            disabled={validationsNumber <= 1}
          >
            {"-"}
          </Button>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  attributeValidators: state.forms.validationTypes,
});

const mapDispatchToProps = {
  getValidationTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(TextAnswer);